module.exports = __webpack_public_path__ + "static/img/female-bg-ar.b1b4784c.png";